import { AuthStorage } from './auth-session-storage';

const LEGACY_PENDING_SESSION_EXPIRY_STORAGE_KEY = 'kh.pending-session-expiry';
export const SESSION_EXPIRY_REDIRECT_QUERY_PARAM = 'session-expired';
export const SESSION_EXPIRY_REDIRECT_QUERY_VALUE = '1';

export function clearLegacyPendingSessionExpiry(
  storage: AuthStorage = localStorage): void {
  storage.removeItem(LEGACY_PENDING_SESSION_EXPIRY_STORAGE_KEY);
}

export function parseSessionExpiryRedirectMarker(
  marker: string | null): boolean {
  return marker === SESSION_EXPIRY_REDIRECT_QUERY_VALUE;
}
